import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
  UnifiedThemeProvider,
} from '@backstage/theme';

const CHI_NAVY = '#100f51';

const chiPageTheme = {
  home: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
  documentation: genPageTheme({
    colors: [CHI_NAVY, '#1c1a7a'],
    shape: shapes.wave,
  }),
  tool: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.round }),
  service: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
  website: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
  library: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
  other: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
  app: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
  apis: genPageTheme({ colors: [CHI_NAVY, '#1c1a7a'], shape: shapes.wave }),
};

const chiLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: CHI_NAVY },
    bursts: {
      ...palettes.light.bursts,
      gradient: {
        linear: `linear-gradient(-137deg, #1c1a7a 0%, ${CHI_NAVY} 100%)`,
      },
    },
    navigation: {
      ...palettes.light.navigation,
      indicator: CHI_NAVY,
    },
    tabbar: { indicator: CHI_NAVY },
  },
  defaultPageTheme: 'home',
  pageTheme: chiPageTheme,
});

const chiDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    bursts: {
      ...palettes.dark.bursts,
      gradient: {
        linear: `linear-gradient(-137deg, #1c1a7a 0%, ${CHI_NAVY} 100%)`,
      },
    },
    navigation: {
      ...palettes.dark.navigation,
      indicator: CHI_NAVY,
    },
    tabbar: { indicator: CHI_NAVY },
  },
  defaultPageTheme: 'home',
  pageTheme: chiPageTheme,
});

export const lightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light Theme',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={chiLightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const darkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark Theme',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={chiDarkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});
